import { createSelector } from 'reselect'

export const selectDict = state => state.dict

export const selectListDictWords = createSelector(
	[selectDict],
	dict => dict.dictWords
)
export const selectTotalDictWord = createSelector(
	[selectDict],
	dict => dict.total
)
export const selectCurrentPageDictWord = createSelector(
	[selectDict],
	dict => dict.currentPage
)

export const selectDictWordTypes = createSelector(
	[selectDict],
	dict => dict.dictWordTypes
)
export const selectTotalDictWordTypes = createSelector(
	[selectDict],
	dict => dict.totalWordType
)
export const selectCurrentPageDictWordTypes = createSelector(
	[selectDict],
	dict => dict.currentPageWordType
)
export const selectCurrentDictWordType = createSelector(
	[selectDict],
	dict => dict.selectedWordType
)
